export default "__VITE_ASSET__DocUNSMA__"